interface ParsedLinkInterface {
    origin?: string;
    path?: string;
    search?: any;
}

/**
 * Get the URL search parameters
 * @param  {String} url The URL
 * @return {Object}     The URL parameters
 */
const getUrlParams = (url: string): ParsedLinkInterface => {
    const params: any = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return {
        origin: parser.origin,
        path: parser.pathname,
        search: params
    };
};

const getYouTubeUrl = (url: string) => {
    const match = url.match(/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})?$/);
    if (match && match[1].length === 11) {
        return 'https://www.youtube.com/embed/' + match[1];
    }
    return '';
}

export { getUrlParams, ParsedLinkInterface, getYouTubeUrl }